import { z } from 'zod';
import { timestampSchema } from './shared';

export const chatMessageRoleEnum = z.enum(['user', 'assistant']);

export const chatMessageRowSchema = z.object({
  id: z.string().min(1),
  conversationId: z.string().min(1),
  role: chatMessageRoleEnum,
  content: z.string(),
  createdAt: timestampSchema,
});

export type ChatMessageRow = z.infer<typeof chatMessageRowSchema>;
